import { NavigationError } from '@angular/router';

const RELOAD_GUARD_KEY = 'ez-chunk-reload-at';
const RELOAD_GUARD_WINDOW_MS = 60_000;

const CHUNK_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
  /loading chunk \S+ failed/i,
  /chunkloaderror/i,
];

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message =
    error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return CHUNK_ERROR_PATTERNS.some(pattern => pattern.test(message));
}

/** Permite no máximo um reload por minuto para não entrar em loop. */
export function shouldReloadOnChunkError(
  now: number,
  storage: Storage = sessionStorage
): boolean {
  const lastReload = Number(storage.getItem(RELOAD_GUARD_KEY) ?? 0);
  if (now - lastReload < RELOAD_GUARD_WINDOW_MS) return false;
  storage.setItem(RELOAD_GUARD_KEY, String(now));
  return true;
}

export function recoverFromChunkLoadError(
  navigationError: NavigationError
): void {
  if (!isChunkLoadError(navigationError.error)) return;
  if (!shouldReloadOnChunkError(Date.now())) return;
  window.location.assign(navigationError.url);
}
